import React, { FC, PropsWithChildren } from 'react';
import { View } from 'react-native';
import HomePageHeader, { HomePageHeaderProps } from '@components/operatorPanel/components/HomePage/HomePageHeader';
import OperatorPanelButton from '@components/operatorPanel/components/elements/buttons/OperatorPanelButton';
import { scale as initialScale } from '@components/frame';
import { isWeb, navigateTo, navigationRef } from '@helpers';
import { ClockInButton } from '@components/operatorPanel/components/HomePage/HomePageTopRightPart';
import { getBoxShadowStyle } from '@styles/shadow';
import { font as initialFont } from '@styles/fonts';
import { OPERATOR_PANEL_PADDING } from '@components/operatorPanel/constants/operatorPanel.constants';
import { PanelProps } from '@components/operatorPanel/components/panel';

export interface UnavailableContentProps
  extends Omit<HomePageHeaderProps, 'bgColor'>,
    Pick<PanelProps, 'insetBottom'>,
    PropsWithChildren {
  testID?: string;
}

const UnavailableContent: FC<UnavailableContentProps> = ({
  CC,
  machineName,
  isOperator,
  children,
  insetTop,
  insetBottom,
  scale = initialScale,
  font = initialFont,
  testID,
}) => {
  const boxShadowStyle = getBoxShadowStyle({ type: 'Very Wide', scheme: 'light' });

  const route = navigationRef?.current?.getCurrentRoute();

  const onScheduledPress = () => {
    navigateTo('OperatorPanelScheduledScreen', { id: route?.params?.id });
  };
  return (
    <View
      testID={testID}
      style={{
        height: isWeb ? '100vh' : '100%',
        width: '100%',
        overflow: 'hidden',
        backgroundColor: CC('Panel/Light/Off'),
        justifyContent: 'center',
        alignItems: 'center',
        gap: scale(54),
      }}
    >
      <HomePageHeader {...{ CC, machineName, bgColor: 'Panel/Light/Off', isOperator, insetTop, scale, font }} />
      {isOperator && (
        <View style={{ position: 'absolute', bottom: scale(OPERATOR_PANEL_PADDING + insetBottom), right: scale(OPERATOR_PANEL_PADDING) }}>
          <OperatorPanelButton
            {...{
              onPress: onScheduledPress,
              customButtonBgColor: 'Button/Light/Operator Panel [Not Productive]',
              CC,
              iconConfig: { icon: 'clock', color: CC('Label/Dark/AlwaysLight Primary'), width: scale(18), height: scale(17) },
              text: 'Scheduled',
              scale,
              font,
            }}
          />
        </View>
      )}
      {children}
      {!isOperator && (
        <ClockInButton
          boxShadowStyle={boxShadowStyle}
          CC={CC}
          bgColor="Gray/Dark/3"
          borderColor="Gray/Dark/3"
          textColor="Label/Light/AlwaysLight Primary"
          iconColor="Label/Light/AlwaysLight Primary"
          scale={scale}
          font={font}
        />
      )}
    </View>
  );
};

export default UnavailableContent;
